module.exports = __webpack_public_path__ + "img/activity_3.2edc5d22.png";